import { css, cx } from "@emotion/css";
import React, { PropsWithChildren, Ref } from "react";

interface BaseProps {
	className?: string;
	[key: string]: unknown;
}

export const Button = React.forwardRef(
	(
		{
			className,
			active,
			reversed,
			...props
		}: PropsWithChildren<
			{
				active?: boolean;
			} & BaseProps
		>,
		ref: Ref<HTMLButtonElement>,
	) => (
		<button
			{...props}
			ref={ref}
			type="button"
			aria-pressed={active ? true : undefined}
			className={cx(
				css`
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 28px;
					height: 28px;
					border: none;
					background: none;
					border-radius: 6px;
					padding: 0;
					margin: 0;
					cursor: pointer;
				`,
				active &&
					css`
						background-color: rgba(120, 155, 115, 0.18);

						svg path {
							fill: #789b73;
						}
					`,
				className,
			)}
		/>
	),
);

export const Menu = React.forwardRef(
	({ className, ...props }: PropsWithChildren<BaseProps>, ref: Ref<HTMLDivElement>) => (
		<div
			{...props}
			data-test-id="menu"
			ref={ref}
			className={cx(
				className,
				css`
					& > * {
						display: inline-block;
					}
				`,
			)}
		/>
	),
);

export const Toolbar = React.forwardRef(
	({ className, ...props }: PropsWithChildren<BaseProps>, ref: Ref<HTMLDivElement>) => (
		<Menu {...props} ref={ref} className={className} />
	),
);
